import React, { createContext, useContext, useState, useEffect } from 'react';
import { authToken } from '../services/api';

// Decode JWT token to extract user info
const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [groupIds, setGroupIds] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    // Load user info from token on mount
    const token = authToken.getAccess();
    if (token) {
      const decoded = decodeJWT(token);
      if (decoded) {
        setUser({
          id: decoded.sub,
          role: decoded.role,
        });
        setGroupIds(decoded.groupIds || []);
        setCustomerId(decoded.customerId);
        setIsSuperAdmin(decoded.isSuperAdmin || false);
      }
    }
  }, []);

  const updateUser = (token) => {
    if (token) {
      const decoded = decodeJWT(token);
      if (decoded) {
        setUser({
          id: decoded.sub,
          role: decoded.role,
        });
        setGroupIds(decoded.groupIds || []);
        setCustomerId(decoded.customerId);
        setIsSuperAdmin(decoded.isSuperAdmin || false);
      }
    }
  };

  const clearUser = () => {
    setUser(null);
    setGroupIds([]);
    setCustomerId(null);
    setIsSuperAdmin(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        groupIds,
        customerId,
        isSuperAdmin,
        updateUser,
        clearUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

